import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { HomeComponent } from '../home/home.component';
import { SigninComponent } from '../signin/signin.component';
import { RegisterComponent } from '../register/register.component';
import { ConnectComponent } from '../connect/connect.component';
import { ListComponent } from '../list/list.component';
import { InfoComponent } from '../info/info.component';
import { ControlComponent } from '../control/control.component';

const routes: Routes = [
    { path: '', redirectTo: 'home', pathMatch: 'full' },
    { path: 'home', component: HomeComponent },
    { path: 'signin', component: SigninComponent },
    { path: 'register', component: RegisterComponent }, 
    { path: 'connect', component: ConnectComponent },
    { path: 'list', component: ListComponent },   
    { path: 'info', component: InfoComponent },   
    { path: 'control', component: ControlComponent }    
];

@NgModule({
    imports: [ RouterModule.forRoot(routes, {useHash: true}) ],
    exports: [ RouterModule ]
})

export class AppRoutingModule { }


// WEBPACK FOOTER //
// /var/www/html/mediate/src/app/app-routing/app-routing.module.ts